import { render, staticRenderFns } from "./LeaderboardEditor.vue?vue&type=template&id=64253088&"
import script from "./LeaderboardEditor.vue?vue&type=script&lang=js&"
export * from "./LeaderboardEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports